import React from 'react';

const LoadingSpinner = ({ message }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-60">
      <div className="flex flex-col items-center p-8 bg-white shadow-2xl rounded-2xl animate-fade-in">
        <div className="w-16 h-16 border-t-4 border-b-4 border-blue-600 rounded-full animate-spin"></div>
        <p className="max-w-xs mt-6 text-lg font-medium text-center text-gray-800">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;